import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from 'react-query';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { GoogleOAuthProvider } from '@react-oauth/google';

import CloseIcon from '@mui/icons-material/Close';

// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
import { ThemeModeProvider } from './contexts/ThemeContext';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import { reactAppClientId } from './config';
import './styles/styles.css';
import { AccountProvider } from './contextAPI/AccountImageContext';

// ----------------------------------------------------------------------

export default function App() {
  const queryClient = new QueryClient();

  //  const messaging = firebase.messaging();

  return (
    <HelmetProvider>
      <ThemeModeProvider>
        <Toaster 
          position="top-right" 
          reverseOrder={false} 
          limit={2}
          toastOptions={{
            style: {
              padding: '12px 16px',
            },
          }}
        >
          {(t) => (
            <ToastBar toast={t}>
              {({ icon, message }) => (
                <>
                  {icon}
                  {message ?? (t.type === 'error' ? 'Something went wrong' : t.type === 'success' ? 'Success' : '')}
                  {t.type !== 'loading' && (
                    <button 
                      type="button" 
                      onClick={() => toast.dismiss(t.id)}
                      style={{
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginLeft: '8px',
                        color: 'inherit',
                        opacity: 0.7,
                        transition: 'opacity 0.2s',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.opacity = '1';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.opacity = '0.7';
                      }}
                    >
                      <CloseIcon sx={{ fontSize: '18px' }} />
                    </button>
                  )}
                </>
              )}
            </ToastBar>
          )}
        </Toaster>
        <QueryClientProvider client={queryClient}>
          {/* <ReactQueryDevtools initialIsOpen/> */}

          <GoogleOAuthProvider clientId={reactAppClientId}>
            <BrowserRouter>
              <ThemeProvider>
                <AccountProvider>
                  <ScrollToTop />
                  <StyledChart />
                  <Router />
                </AccountProvider>
              </ThemeProvider>
            </BrowserRouter>
          </GoogleOAuthProvider>
        </QueryClientProvider>
      </ThemeModeProvider>
    </HelmetProvider>
  );
}
